import DateTimeMixin from './date-time';

export default {
  mixins: [DateTimeMixin],
  computed: {
    rules() {
      const fieldRequired = this.$i18n_t('Common.inputRules.required');
      return {
        required: function (v) {
          switch (typeof v) {
            case 'string':
              return v.length > 0 || fieldRequired;
            case 'number':
              return !isNaN(v) || fieldRequired;
            default:
              return v || fieldRequired;
          }
        },
        date: (value) => this.dateTimeIsValid(value) || this.$i18n_t('Common.inputRules.date.invalid'),
      };
    },
  },
  methods: {},
};
